import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import {
  Card,
  Box,
  Typography,
  Button,
  CircularProgress,
  Chip,
  Divider,
  Stack,
  Avatar,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.DELIVERY_TERMS.BASE;

const DeliveryTermDetailsContent = () => {
  const { id } = useParams();
  const [deliveryTerm, setdeliveryTerm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchdeliveryTerm();
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchdeliveryTerm = async () => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      setdeliveryTerm(response.data.deliveryTerm);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching delivery term details:", error);
      setSnackbar({
        open: true,
        message: "Failed to load delivery term details",
        severity: "error",
      });
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />;
  }

  if (!deliveryTerm) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
        Delivery Term not found
      </Typography>
    );
  }

  return (
    <Box component="section" sx={{ p: { xs: 1, sm: 3 } }}>
      <Card
        sx={{
          boxShadow: 4,
          borderRadius: "16px",
          p: { xs: 2, sm: 4 },
          maxWidth: 600,
          margin: "auto",
          mt: 5,
          background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
          <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48 }}>
            <LocalShippingIcon fontSize="large" />
          </Avatar>
          <Typography variant="h4" sx={{ fontWeight: "bold", flexGrow: 1 }}>
            Delivery Term Details
          </Typography>
          <Link to="/ecommerce/delivery-terms-list" style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ borderRadius: 2, fontWeight: 500 }}
            >
              Back
            </Button>
          </Link>
        </Stack>

        <Divider sx={{ mb: 3 }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Name
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: 0.5 }}>
            {deliveryTerm.name}
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Publish Status
          </Typography>
          <Chip
            icon={
              deliveryTerm.publish ? (
                <CheckCircleIcon style={{ color: "#fff" }} />
              ) : (
                <CancelIcon style={{ color: "#fff" }} />
              )
            }
            label={deliveryTerm.publish ? "Published" : "Unpublished"}
            color={deliveryTerm.publish ? "success" : "default"}
            size="medium"
            sx={{
              fontWeight: 500,
              fontSize: 16,
              px: 2,
              py: 0.5,
              color: "#fff",
              borderRadius: 2,
              ...(deliveryTerm.publish ? {} : { backgroundColor: '#e53935' }),
            }}
          />
        </Box>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DeliveryTermDetailsContent;
